export function autoSizeAll(params) {
  var columns = [];
  params.columnApi.getAllColumns().forEach(function (column) {
    columns.push(column.colId);
  });
  params.columnApi.autoSizeColumns(columns, false);
}
